// extracted by mini-css-extract-plugin
module.exports = {"onestorycard-sixstorylist":"onestorycard-sixstorylist-module__onestorycard-sixstorylist__1HbtD"};